import { gql } from '@apollo/client'

export const createPaymentTransactionMutation = gql`
  mutation createPaymentTransaction($input: CreatePaymentTransactionInput!) {
    createPaymentTransaction(input: $input) {
      id
      paymentUrl
    }
  }
`

export const activateLayersUserMutation = gql`
  mutation activateLayersUser(
    $userId: Int!
    $entityId: Int!
    $degree: String!
    $externalTransactionId: String!
  ) {
    activateLayersUser(
      userId: $userId
      entityId: $entityId
      degree: $degree
      externalTransactionId: $externalTransactionId
    ) {
      userId
      entityId
      degree
    }
  }
`
